module.exports = __webpack_public_path__ + "bg2.jpg?9f37285c398588fb1b47561c581800fb";


//////////////////
// WEBPACK FOOTER
// ./dist/bg/bg2.jpg
// module id = 243
// module chunks = 0